import styled from 'styled-components';
import { Children, ReactNode } from 'react';
import LS from "../styles/layoutStyled";
import CS from "../styles/componentStyled";
import { delConfirmText, modifyConfirmText } from '../atom/ModalAtom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useEffect, useState } from "react";

interface AlarmModal3Props {
    modalType: string;
    onClose : () => void;
    onConfirm : () => void;
}

const AlarmModal3 = ({ modalType, onClose, onConfirm }: AlarmModal3Props) => {
    const delText = useRecoilValue(delConfirmText);
    const modifyText = useRecoilValue(modifyConfirmText);

    return (
        <>
            <CS.ModalBg>
                <CS.ModalType1>
                    {modalType === 'del' && (
                        <p>{delText}</p>
                    )}
                    {modalType === 'modify' && (
                        <p>{modifyText}</p>
                    )}
                    <div className="btn-box">
                        <CS.Btn2Type2 type='button' onClick={onClose}>취소</CS.Btn2Type2>
                        <CS.Btn2Type1 type='button' onClick={onConfirm}>확인</CS.Btn2Type1>
                    </div>
                </CS.ModalType1>
            </CS.ModalBg>
        </>
    );
}

export default AlarmModal3;